<div class="detail-container">
    @if (roomPropertyResource.isLoading()) {
    <property-skeleton />
    } @else if (roomPropertyResource.error()) {
        <error-card/>
    } @else {
        @if (roomPropertyResource.value(); as room) {
        <div class="d-flex gap-4">
            <div>
                <div class="d-flex justify-content-between align-items-center">
                    <section-header>{{ roomHeader() }}</section-header>
                    @if (is3DViewerEnable()) {
                    <is-busy-button id="button3" 
                            (execute)="close3DViewer()"
                            [disabled]="false" 
                            css="btn w-100 clip3 corner position-relative primary-border primary-text-100 font-4 rounded-0 py-2">
                        <span>Close</span>
                    </is-busy-button>
                    }
                </div>
                @if (is3DViewerEnable()) {
                    <div class="part-viewer">
                        <!-- <unity
                          style="display: block; width: 100%; height: 100%;"
                            [cacheContext]="RoomPropertyComponent.cacheContext"
                            [config]="config()"
                            [params]="params()"
                            [security]="security()"
                            [width]="'800px'"
                            [height]="'500px'" /> -->
                    </div>
                } @else {
                    <div class="d-flex flex-wrap gap-4">
                        <!-- [style.view-transition-name]="'card-image-' + room.id" -->
                        <document-card    class="document-card">
                            @if (room.hasImageError()) {
                                <span class="text-center" card-content>{{room.name()}}</span>
                            } @else {
                                <img card-content class="h-100" (error)="room.handleImageError()" [src]="room.thumbnailUrl()" alt="image" />
                            }

                            @if (room.partId()) {
                                <is-busy-button card-footer id="open-button" [disabled]="false" (execute)="open3DViewer()"
                                    css="btn w-100 clip3 corner position-relative primary-border secondary-bg secondary-text-100 rounded-0 py-1">
                                    <span class="font-4">Open</span>
                                </is-busy-button>
                            } @else {
                                <span card-footer class="font-5">{{room.name()}}</span>
                            }
                        </document-card>
                    </div>
                }
            </div>
        </div>

        <div class="mt-4">
            <section-header>Room Properties</section-header>

            <div class="masonry-columns">
                @for (category of filteredCategories(); track $index) {
                <property-card>
                    <div role="button" (click)="onCategorySelected(category)" title class="d-flex align-items-center">
                        @if(!category.hasImageError()) {
                            <img height="50" src="{{category.thumbnailUrl()}}" (error)="category.handleImageError()"/>
                        }
                        <span>{{ category.name() }}</span>
                    </div>

                    <div content class="d-flex flex-column gap-3 primary-text">
                        <property-item-header />

                        @for (property of category.properties(); track $index) {
                        <property-item-row [propertyType]="propertyType.Room" [name]="property.name()" [value]="property.values()"></property-item-row>
                        }

                        @for (property of category?.roomContents(); track $index) {
                        <property-item-row 
                            [propertyType]="propertyType.RoomContent"
                            [name]="property.code() ? (property.name().includes(property.code()) ? property.name() : property.code() + ' - ' + property.name()) : property.name()" 
                            [value]="property.quantity()"></property-item-row>
                        }
                    </div>
                </property-card>
                } @empty {
                <empty-property-card />
                }
            </div>
        </div>

        @if (room.documents().length; as length) {
            <div class="mt-4">
                <carousel [enableHover]="true" [dataSource]="room.documents()" class="carousel z-3">
                    <span carousel-label>Room Documents ({{length}})</span>
                </carousel>
            </div>
        }

        @if (roomContents().length; as length) {
            <div class="mt-4">
                <carousel [shouldAddBreadcrumb]="false" [dataSource]="roomContents()" [showCount]="true" class="carousel-bottom-center carousel">
                    <span carousel-label>Room Content ({{length}})</span>
                </carousel>
            </div>
        }

        }
    }
</div>